var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg200MlE(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 45,
    viewBox: "0 0 30 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    d: "M29 12l-12-1-10-1-5-1v32l2 2h22l2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    stroke: "#47464A",
    strokeWidth: 0.5,
    d: "M27.133 1H2.867C1.837 1 1 1.837 1 2.867v36.4a4.67 4.67 0 0 0 4.665 4.666h18.668A4.672 4.672 0 0 0 29 39.266v-36.4C29 1.838 28.162 1 27.133 1zm0 38.266c0 1.544-1.256 2.8-2.8 2.8H5.665a2.803 2.803 0 0 1-2.798-2.8v-.933h24.266v.933zm0-2.8H2.867V10.341c3.953.057 6.03.47 8.216.908 2.18.437 11.9.886 16.05.944v24.273zm0-26.139c-3.953-.057-13.497-.47-15.684-.909-2.18-.436-4.432-.885-8.582-.944V2.867l24.266-.001v7.461z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg200MlE);
export default __webpack_public_path__ + "static/media/200_ml_e.8e9e88462e88b0cac43ead0cfd3544a2.svg";
export { ForwardRef as ReactComponent };